import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { ServiceTypesList } from '@/features/organizations/settings/service-types/service-types-list'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/service-types'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: ServiceTypesPage,
})

function ServiceTypesPage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()

  if (isPending) {
    return (
      <Main>
        <div className='py-8 text-center'>
          <p className='text-muted-foreground'>Loading organization...</p>
        </div>
      </Main>
    )
  }

  return <ServiceTypesList organizationId={activeOrganization?.id || ''} />
}
